<template>
    <div class="tag" :class="color">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "tag",
        props: {
            color: {
                type: String,
                required: false,
            }
        }
    }
</script>

<style scoped lang="scss">
    .tag {
        display: flex;
        justify-content: center;
        align-items: center;

        height: 22px;
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        padding: 0 10px;
        border-radius: 2px;

        background-color: rgba($text_gray, 0.12);
        color: $text_gray;

        &.blue {
            background-color: $blue_transparent;
            color: $blue;
        }

        &.green {
            background-color: $green_transparent;
            color: $green;
        }

        &.purple {
            background-color: $purple_transparent;
            color: $purple;
        }

        &.orange {
            background-color: $orange_transparent;
            color: $orange;
        }

        &.red {
            background-color: $red_transparent;
            color: $red;
        }

        &.pink {
            background-color: $pink_transparent;
            color: $pink;
        }

        &.aqua {
            background-color: $aqua_transparent;
            color: $aqua;
        }
    }
</style>